import { Loader, Plus } from "lucide-react";
import CoinFluxi from "../../../assets/icons/coin-fluxi.svg";

interface ChipProps {
  text: string;
  value: string;
  onClick: () => void;
  loading: boolean;
  compact?: boolean;
}

const COIN_GOLD_FILTER = "brightness(0) saturate(100%) invert(67%) sepia(54%) saturate(1000%) hue-rotate(5deg) brightness(98%) contrast(89%)";

export const Chip = ({ text, value, onClick, loading, compact = false }: ChipProps) => {

  return (
    <div className="flex items-center">
      <div
        className="rounded-full flex items-center pl-4 pr-1.5 py-1.5 gap-3"
        style={{
          border: "1.5px solid hsl(230 10% 78%)",
        }}
      >
        <div className="flex items-center gap-1.5">
          <img
            src={CoinFluxi}
            alt="credits"
            className="w-6 h-6"
            style={{ filter: COIN_GOLD_FILTER }}
          />
          <span
            className="font-bold text-lg tabular-nums leading-none"
            style={{ color: "hsl(230 10% 35%)" }}
          >
            {loading ? (
              <Loader size={16} color="#4368E5" />
            ) : (
              Number(value).toLocaleString()
            )}
          </span>
        </div>
        <button
          onClick={onClick}
          className="w-8 h-8 shrink-0 rounded-full flex items-center justify-center transition-all hover:shadow-lg"
          style={{
            background: "linear-gradient(135deg, rgb(67, 104, 229), rgb(47, 110, 218))",
            boxShadow: "0 4px 12px rgba(47, 110, 218, 0.3)",
          }}
        >
          <Plus className="w-4 h-4 text-white" />
        </button>
      </div>
    </div>
  );
};
